import { Formik } from "formik";
import { useTranslation } from "react-i18next";
import { ResiduoSolidoUrbanoSchema } from "../data/ResiduoSolidoUrbanoSchema";
import Grid from "./layout/Grid";
import Panel from "./layout/Panel";
import Row from "./layout/Row";
import Col from "./layout/Col";
import Label from "./controls/Label";
import TextField from "./controls/TextField";
import { isInvalid } from "../utils/forms";
import AmmountField from "./controls/AmmountField";
import CheckboxField from "./controls/CheckboxField";
import SelectField from "./controls/SelectField";
import Pagination from "./controls/Pagination";
import Button from "./controls/Button";

export function ResiduoSolidoUrbanoForm({
  value,
  page,
  pages,
  select,
  append,
  remove,
  replace,
  unidadCantidad,
  operacionesUnitarias,
  materiales,
  destinos,
  disabled,
}) {
  const { t } = useTranslation();
  return (
    <Formik
      initialValues={value}
      enableReinitialize={true}
      validateOnChange={true}
      validationSchema={ResiduoSolidoUrbanoSchema}
      onSubmit={(values) => {
        if (page === -1) {
          append(values);
        } else {
          replace(values, page);
        }
      }}
    >
      {(residuoSolidoUrbanoForm) => (
        <Grid as={<Panel />} className="formulario embebido">
          <Row>
            <Col>
              <Label>{t("residuoSolidoUrbanoForm.titulo")}</Label>
            </Col>
          </Row>
          <Row>
            <Col>
              <TextField
                id="residuoSolidoUrbano_descripcion"
                name="descripcion"
                label={t("residuoSolidoUrbano.descripcion")}
                value={residuoSolidoUrbanoForm.values?.descripcion}
                onChange={(event) =>
                  residuoSolidoUrbanoForm.handleChange(event)
                }
                isInvalid={isInvalid("descripcion", residuoSolidoUrbanoForm)}
                error={t(residuoSolidoUrbanoForm.errors.descripcion)}
                disabled={disabled}
              />
            </Col>
          </Row>
          <Row>
            <Col lg={4}>
              <AmmountField
                id="residuosSolidoUrbano_cantidad"
                name="cantidad"
                label={t("residuoSolidoUrbano.cantidad")}
                value={residuoSolidoUrbanoForm.values?.cantidad}
                onChange={(event) =>
                  residuoSolidoUrbanoForm.handleChange(event)
                }
                unit={unidadCantidad}
                isInvalid={isInvalid("cantidad", residuoSolidoUrbanoForm)}
                error={t(residuoSolidoUrbanoForm.errors.cantidad)}
                disabled={disabled}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <CheckboxField
                id="residuoSolidoUrbano_operacionesUnitarias"
                name="operacionesUnitarias"
                label={t("residuoSolidoUrbano.operacionesUnitarias")}
                value={residuoSolidoUrbanoForm.values?.operacionesUnitarias}
                onChange={(event) =>
                  residuoSolidoUrbanoForm.handleChange(event)
                }
                options={operacionesUnitarias}
                labelAttr="nombre"
                valueAttr="orden"
                lg={6}
                isInvalid={isInvalid(
                  "operacionesUnitarias",
                  residuoSolidoUrbanoForm,
                )}
                error={t(residuoSolidoUrbanoForm.errors.operacionesUnitarias)}
                disabled={disabled}
              />
            </Col>
          </Row>

          <Row>
            <Col>
              <SelectField
                id="residuoSolidoUrbano_material"
                name="material"
                label={t("residuoSolidoUrbano.material")}
                value={residuoSolidoUrbanoForm.values?.material}
                onChange={(event) =>
                  residuoSolidoUrbanoForm.handleChange(event)
                }
                options={materiales}
                labelAttr="nombre"
                valueAttr="codigo"
                emptyLabel="..."
                isInvalid={isInvalid("material", residuoSolidoUrbanoForm)}
                error={t(residuoSolidoUrbanoForm.errors.material)}
                disabled={disabled}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <SelectField
                id="residuoSolidoUrbano_destino"
                name="destino"
                label={t("residuoSolidoUrbano.destino")}
                value={residuoSolidoUrbanoForm.values?.destino}
                onChange={(event) =>
                  residuoSolidoUrbanoForm.handleChange(event)
                }
                options={destinos}
                labelAttr="nombre"
                valueAttr="codigo"
                emptyLabel="..."
                isInvalid={isInvalid("destino", residuoSolidoUrbanoForm)}
                error={t(residuoSolidoUrbanoForm.errors.destino)}
                disabled={disabled}
              />
            </Col>
          </Row>
          <Row style={{ display: "flex", flexWrap: "wrap" }}>
            <Col lg={6}>
              <Pagination
                sm
                page={page}
                pages={pages}
                onChange={(event) => select(event.target.value)}
              />
            </Col>
            <Col lg={6}>
              <span
                style={{
                  float: "right",
                  alignContent: "center",
                }}
              >
                {page !== -1 && pages > 0 && (
                  <Button
                    sm
                    variant="success"
                    value={t("residuoSolidoUrbanoForm.nuevo")}
                    onClick={(event) => {
                      event.preventDefault();
                      select(-1);
                    }}
                    disabled={disabled}
                  />
                )}
                {page !== -1 && (
                  <Button
                    sm
                    variant="danger"
                    value={t("residuoSolidoUrbanoForm.eliminar")}
                    onClick={(event) => {
                      event.preventDefault();
                      remove(page);
                    }}
                    disabled={disabled}
                  />
                )}
                <Button
                  sm
                  variant="primary"
                  value={t("residuoSolidoUrbanoForm.guardar")}
                  onClick={(event) => {
                    event.preventDefault();
                    residuoSolidoUrbanoForm.submitForm();
                  }}
                  disabled={disabled}
                />
                {page === -1 && (
                  <Button
                    sm
                    variant="default"
                    value={t("residuoSolidoUrbanoForm.cancelar")}
                    onClick={(event) => {
                      event.preventDefault();
                      select(-1);
                    }}
                    disabled={disabled}
                  />
                )}
              </span>
            </Col>
          </Row>
        </Grid>
      )}
    </Formik>
  );
}
